export default (axios, baseURL) => async (clientSid) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/external-idp-oidc`;

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
